"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/OnboardingPayment/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _hooks = require('web/services/hooks');



var _upgrade = require('shared/enum/upgrade');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _gotoURL = require('web/services/gotoURL');
var _app = require('shared/selectors/app');
var _user = require('shared/selectors/user');












var _onboardingAnalytics = require('web/services/onboardingAnalytics');

var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _components = require('web/screens/Signup/components');
var _supportUrls = require('shared/data/supportUrls');








var _onboardingShared = require('web/screens/onboardingShared');
var _Form3 = require('web/screens/Settings/Org/SubscriptionsTab/Features/ExtraPhoneNumber/PhonePickerModal/Form'); var _Form4 = _interopRequireDefault(_Form3);
var _useSmsTrialEligibility = require('web/hooks/useSmsTrialEligibility');
var _TrialOffer = require('web/screens/onboardingShared/TrialOffer'); var _TrialOffer2 = _interopRequireDefault(_TrialOffer);








var _paymentContinuity = require('web/screens/onboardingShared/paymentContinuity'); _createNamedExportFrom(_paymentContinuity, 'clearPaymentContinuity', 'clearPaymentContinuity'); _createNamedExportFrom(_paymentContinuity, 'hasCancelledContinuity', 'hasCancelledContinuity'); _createNamedExportFrom(_paymentContinuity, 'isAuthoritativeSettlement', 'isAuthoritativeSettlement'); _createNamedExportFrom(_paymentContinuity, 'isValidAttempt', 'isValidAttempt');








// sessionStorage-backed one-shot guards so a refresh of a return leg (or a
// StrictMode double-mount) never re-emits a funnel event for the same
// org/status/attempt.
const alreadyEmitted = (key) => {
  try {
    return !!sessionStorage.getItem(key)
  } catch (e) {
    return false
  }
}
const markEmitted = (key) => {
  try {
    sessionStorage.setItem(key, '1')
  } catch (e2) {
    // best-effort; storage may be unavailable in private modes
  }
}
const emitOnce = (key, emit) => {
  if (alreadyEmitted(key)) return
  markEmitted(key)
  emit()
}

// Success-leg settle poll: how long we wait for the checkout webhook to link
// the Stripe subscription (and expose the purchased entitlements) before
// treating it as a failure. ~30s comfortably covers normal webhook lag.
// NOTE: the budget is ATTEMPTS, not wall-time — effect re-runs (socket blips)
// poll immediately and still consume an attempt, so a flaky connection can
// reach the timeout surface early. That's the safe direction (the surface is
// recoverable via Try again); never assume 15 attempts == exactly 30s.
 const SETTLE_POLL_MS = 2000; exports.SETTLE_POLL_MS = SETTLE_POLL_MS
 const SETTLE_MAX_ATTEMPTS = 15; exports.SETTLE_MAX_ATTEMPTS = SETTLE_MAX_ATTEMPTS
const OnboardingPayment = () => {
  const { status } = _reactrouterdom.useParams()
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const clientOpen = _hooks.useAppSelector.call(void 0, _app.selectIsClientOpen)
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)

  const params = _react.useMemo.call(void 0, () => new URLSearchParams(search), [search])
  const orgParam = (params.get('org') || '') 
  const attemptParam = params.get('attempt') || undefined

  const isValidOrg = !!orgParam && _onboardingAnalytics.getNonPendingAdminOrgKeys.call(void 0, _optionalChain([currentUser, 'optionalAccess', _ => _.Relationships])).includes(orgParam)
  // The cancelled return leg re-renders the offer so the user can retry checkout;
  // pricing must reload for it just like the fresh offer view. (The attempt id
  // rides the URL, so onStart still targets the same checkout cycle.)
  const isOfferView = status === undefined || status === 'cancelled'
  const org = _hooks.useAppSelector.call(void 0, s => (s.orgs || {})[orgParam])

  // One attempt id per checkout cycle, minted once on mount and stable for the
  // component's lifetime.
  const [attemptId] = _react.useState(() => {
    if (!orgParam) return undefined
    if (status === undefined) {
      return _paymentContinuity.getOrCreateOrgAttempt.call(void 0, orgParam)
    }
    if (_paymentContinuity.isValidAttempt.call(void 0, attemptParam)) return attemptParam
    return undefined
  })

  const guardKey = (kind) => `onb_pay_${orgParam}_${kind}_${attemptId}`

  const continuityValid = !!attemptId && _paymentContinuity.hasCancelledContinuity.call(void 0, orgParam, attemptId)
  const [items, setItems] = _react.useState([])
  const [isLoadingPricing, setIsLoadingPricing] = _react.useState.call(void 0, true)
  const [hasPricingError, setHasPricingError] = _react.useState.call(void 0, false)
  const [isStarting, setIsStarting] = _react.useState.call(void 0, false)
  const startingRef = _react.useRef.call(void 0, false)
  const [hasCheckoutError, setHasCheckoutError] = _react.useState.call(void 0, false)
  const [phoneSkipDialogOpen, setPhoneSkipDialogOpen] = _react.useState.call(void 0, false)
  const [selectedTier, setSelectedTier] = _react.useState()

  const survey = _onboardingShared.useOnboardingSurvey.call(void 0, orgParam, isValidOrg)
  const hasSms = _onboardingShared.surveyHasSms.call(void 0, survey)
  const hasTeamChat = _onboardingShared.surveyHasTeamChat.call(void 0, survey)
  const hasExternalChat = _onboardingShared.surveyHasExternalChat.call(void 0, survey)

  // The offer is an SMS decision; the free-team card was removed. A
  // team-chat-only org landing on the initial offer route has nothing to
  // decide — clean the attempt and land on the confirmation instead of a
  // blank offer. (Success/cancelled return legs manage themselves.)
  _react.useEffect.call(void 0, () => {
    if (!survey.loaded || hasSms || !isValidOrg || !orgParam || status) return
    _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
    _actions2.default.gotoOnboardingDemo(orgParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [survey.loaded, hasSms, isValidOrg, orgParam, status])
  const isEnterprise = _onboardingShared.surveyIsEnterpriseVolume.call(void 0, survey)

  // A foreign / unresolved org sends the user to the inbox. Wait for auth bootstrap.
  _react.useEffect.call(void 0, () => {
    if (currentUser && !isValidOrg) _actions2.default.gotoInbox()
  }, [currentUser, isValidOrg])

  // Post-checkout number provisioning (SMS trials): resolved when the signer
  // registers a number or defers. Non-SMS carts have no number to provision.
  const [phoneResolved, setPhoneResolved] = _react.useState.call(void 0, false)

  // The success leg branches (phone picker vs straight to inbox) on the
  // SETTLED subscription, never the survey: `checkout.session.completed`
  // routinely lands after the browser follows the success URL (no entitlement
  // linked yet, so RegisterPhone would reject every number), and the checkout
  // itself may differ from the survey intent. Poll until a purchased item
  // reports Enabled, then
  // branch on the SMS item. A timeout is a real failure for a PAYING user —
  // Sentry + step_errored + a contact-support surface, never a silent picker.
  const [settleState, setSettleState] = _react.useState('pending')
  const successAuthorized = status === 'success' &&
    (settleState === 'sms' || settleState === 'no_sms')
  // Attempt count lives in a ref, not the effect closure: a WebSocket blip
  // mid-window re-runs the effect (clientOpen toggles), and a closure-local
  // counter would restart from zero each time — a flaky connection could keep
  // the poll alive forever without ever reaching the timeout surface. Reset
  // only when a new poll round is explicitly requested ("Try again").
  const settleAttemptsRef = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (status !== 'success' || !isValidOrg || !orgParam || !clientOpen) return undefined
    if (settleState !== 'pending') return undefined
    let cancelled = false
    let timer = null
    const schedule = () => {
      settleAttemptsRef.current += 1
      if (settleAttemptsRef.current >= exports.SETTLE_MAX_ATTEMPTS) {
        log.error(new Error('onboarding checkout success leg: subscription never settled'))
        _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, {
          error_kind: 'subscription_settle', organization_id: orgParam, attempt_id: attemptId, ..._onboardingAnalytics.PAYMENT_STEP_META,
        })
        setSettleState('timeout')
        return
      }
      timer = window.setTimeout(poll, exports.SETTLE_POLL_MS)
    }
    const poll = () => {
      _actions2.default.getSubscription({ OrgKey: orgParam })
        .then(r => {
          if (cancelled) return
          if (!_paymentContinuity.isAuthoritativeSettlement.call(void 0, r.OnboardingAttempt, attemptId)) {
            schedule()
            return
          }
          const settled = (r.Items || []).filter(i => i.Enabled)
          if (!settled.length) {
            schedule()
            return
          }
          setSettleState(settled.some(i => i.Type === _upgrade.SubscriptionItemType.SMS) ? 'sms' : 'no_sms')
        })
        .catch(() => { if (!cancelled) schedule() })
    }
    poll()
    return () => {
      cancelled = true
      if (timer !== null) window.clearTimeout(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, isValidOrg, orgParam, clientOpen, settleState, attemptId])

  const finishToReady = _react.useCallback.call(void 0, () => {
    _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
    _actions2.default.gotoOnboardingSteps(orgParam)
  }, [orgParam])

  // Success return: the trial started → drop cached SMS-trial eligibility so the
  // declined banner self-extinguishes. SMS-entitled carts then provision their
  // number before landing in the inbox; everyone else lands once settled.
  _react.useEffect.call(void 0, () => {
    if (!isValidOrg || !orgParam) return
    if (status === 'success') {
      if (!successAuthorized) return
      emitOnce(guardKey('success'), () =>
        _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED, {
          ..._onboardingAnalytics.PAYMENT_STEP_META, organization_id: orgParam, attempt_id: attemptId,
        }))
      _useSmsTrialEligibility.invalidateSmsTrialEligibility.call(void 0, orgParam)
      if (settleState === 'no_sms' || (settleState === 'sms' && phoneResolved)) finishToReady()
    } else if (status === 'cancelled') {
      if (!continuityValid) return
      emitOnce(guardKey('cancelled'), () =>
        _onboardingAnalytics.captureOnboardingPaymentAbandoned.call(void 0, {
          outcome: 'checkout_cancelled', organization_id: orgParam, attempt_id: attemptId,
        }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isValidOrg,
    orgParam,
    status,
    attemptId,
    settleState,
    phoneResolved,
    finishToReady,
    successAuthorized,
    continuityValid,
  ])

  // The payment step is viewed once the offer renders.
  _react.useEffect.call(void 0, () => {
    if (!isValidOrg || !orgParam || !isOfferView) return
    emitOnce(guardKey('viewed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED, {
        ..._onboardingAnalytics.PAYMENT_STEP_META, organization_id: orgParam, attempt_id: attemptId,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidOrg, orgParam, isOfferView, attemptId])

  const loadPricing = _react.useCallback.call(void 0, () => {
    if (!orgParam) return
    setHasPricingError(false)
    setIsLoadingPricing(true)
    _actions2.default.getSubscription({ OrgKey: orgParam })
      .then(r => {
        setItems(r.Items || [])
        setIsLoadingPricing(false)
      })
      .catch(err => {
        log.error(err instanceof Error ? err : String(err))
        _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, {
          error_kind: 'pricing_load', organization_id: orgParam, ..._onboardingAnalytics.PAYMENT_STEP_META,
        })
        setHasPricingError(true)
        setIsLoadingPricing(false)
      })
  }, [orgParam])

  // Load pricing once the survey settles (so the enterprise cutoff is known)
  // and we're on the non-enterprise offer view.
  _react.useEffect.call(void 0, () => {
    if (isOfferView && survey.loaded && clientOpen && isValidOrg && !isEnterprise) {
      loadPricing()
    }
  }, [isOfferView, survey.loaded, clientOpen, isValidOrg, isEnterprise, loadPricing])

  // Number-provisioning step callbacks (SMS success leg).
  const onPhoneRegistered = _react.useCallback.call(void 0, () => {
    emitOnce(guardKey('phone_completed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED, {
        ..._onboardingAnalytics.PHONE_STEP_META, organization_id: orgParam, attempt_id: attemptId,
      }))
    setPhoneResolved(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])
  const onPhoneSkip = _react.useCallback.call(void 0, () => {
    emitOnce(guardKey('phone_skipped'), () =>
      _onboardingAnalytics.captureOnboardingPaymentAbandoned.call(void 0, {
        outcome: 'phone_skipped', organization_id: orgParam, attempt_id: attemptId,
      }))
    setPhoneResolved(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])
  const reloadSubscription = _react.useCallback.call(void 0, 
    () => _actions2.default.getSubscription({ OrgKey: orgParam }).then(() => undefined),
    [orgParam],
  )

  const onStart = _react.useCallback.call(void 0, async (action) => {
    if (!orgParam || !_paymentContinuity.isValidAttempt.call(void 0, attemptId)) return
    if (hasSms && !action.selectedSmsItem) return
    // Ref guard, not state: React 17 doesn't batch the setIsStarting render
    // outside event handlers, so a rapid double-click re-enters before the
    // button disables — each entry would mint its own Stripe checkout session.
    if (startingRef.current) return
    startingRef.current = true
    // The backend rebuilds the cart server-canonically (live-membership seats,
    // server-priced tiers) but honors this request's SMS selection: its
    // messaging units are the freshest volume signal (the slider re-tiers
    // after the survey), and omitting the messaging line drops SMS entirely.
    const canonicalCart = [
      { Type: _upgrade.SubscriptionItemType.TEAM, Units: 1 },
      ...(hasSms && action.selectedSmsItem
        ? [{ Type: _upgrade.SubscriptionItemType.SMS, Units: action.selectedSmsItem.Units }]
        : []),
    ]
    // Intent signal before the Stripe redirect — the only point where the
    // configured plan is still in state for a checkout that completes.
    emitOnce(guardKey('checkout_started'), () =>
      _onboardingAnalytics.captureOnboardingCheckoutStarted.call(void 0, {
        organization_id: orgParam, attempt_id: attemptId, ...action.estimates,
      }))
    setHasCheckoutError(false)
    setIsStarting(true)
    try {
      const { URL } = await _actions2.default.getCheckoutURL({
        OrgKey: orgParam,
        Items: canonicalCart,
        SuccessURL: _paymentContinuity.buildOnboardingReturnURL.call(void 0, 'success', orgParam, attemptId),
        CancelURL: _paymentContinuity.buildOnboardingReturnURL.call(void 0, 'cancelled', orgParam, attemptId),
        OnboardingTrial: true,
        AttemptID: attemptId,
      })
      _gotoURL.gotoURL.call(void 0, URL)
    } catch (err) {
      log.error(err instanceof Error ? err : String(err))
      _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, {
        error_kind: 'checkout_start', organization_id: orgParam, attempt_id: attemptId, ..._onboardingAnalytics.PAYMENT_STEP_META,
      })
      startingRef.current = false
      setIsStarting(false)
      setHasCheckoutError(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId, hasSms])

  const onSkipToReady = _react.useCallback.call(void 0, (action) => {
    emitOnce(guardKey('skipped'), () =>
      _onboardingAnalytics.captureOnboardingPaymentAbandoned.call(void 0, {
        outcome: 'skipped', organization_id: orgParam, attempt_id: attemptId, ...action.estimates,
      }))
    _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
    _actions2.default.gotoOnboardingDemo(orgParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])

  const onSkipOpen = _react.useCallback.call(void 0, (action) => {
    emitOnce(guardKey('skip_dialog'), () =>
      _onboardingAnalytics.captureOnboardingSkipDialogViewed.call(void 0, {
        organization_id: orgParam, attempt_id: attemptId, ...action.estimates,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])

  const onFreeContinue = _react.useCallback.call(void 0, (action) => {
    emitOnce(guardKey('free_team'), () =>
      _onboardingAnalytics.captureOnboardingPaymentAbandoned.call(void 0, {
        outcome: 'free_team', organization_id: orgParam, attempt_id: attemptId, ...action.estimates,
      }))
    _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
    _actions2.default.gotoOnboardingDemo(orgParam)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])

  // Legacy survey over-cutoff branch. The shared dropdown reports its own
  // enterprise callout through onDemoViewed below.
  _react.useEffect.call(void 0, () => {
    if (!isValidOrg || !orgParam || !isOfferView || !survey.loaded || !isEnterprise) return
    emitOnce(guardKey('demo_viewed'), () =>
      _onboardingAnalytics.captureOnboardingDemoCalloutViewed.call(void 0, {
        source: 'enterprise_branch',
        trigger: 'survey_volume',
        organization_id: orgParam,
        attempt_id: attemptId,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValidOrg, orgParam, isOfferView, survey.loaded, isEnterprise, attemptId])

  const onDemoClick = _react.useCallback.call(void 0, (
    source,
    action,
  ) => {
    _onboardingAnalytics.captureOnboardingDemoClicked.call(void 0, {
      source,
      trigger: source === 'enterprise_branch' ? 'survey_volume' : 'patients',
      organization_id: orgParam,
      attempt_id: attemptId,
      ..._optionalChain([action, 'optionalAccess', _2 => _2.estimates]),
    })
    _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
    _gotoURL.gotoURL.call(void 0, _supportUrls.scheduleMeetingUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])

  const onDemoViewed = _react.useCallback.call(void 0, (action) => {
    emitOnce(guardKey('demo_viewed'), () =>
      _onboardingAnalytics.captureOnboardingDemoCalloutViewed.call(void 0, {
        source: 'enterprise_callout',
        trigger: 'patients',
        organization_id: orgParam,
        attempt_id: attemptId,
        ...action.estimates,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgParam, attemptId])

  // Wait for the auth bootstrap and org record; the redirect effect handles a
  // foreign org before any signer or checkout work can start.
  if (!currentUser || !isValidOrg || !org) return _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 434}}, _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 434}} ))

  // Success leg: SMS-entitled subscriptions pick their BloomText number before
  // the inbox; everyone else is navigated there by the effect above once the
  // subscription settles. The branch reads the SETTLED entitlement, never the
  // survey (see the settle-poll effect).
  if (status === 'success') {
    if (settleState === 'timeout') {
      return (
        _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 443}}
          , _react2.default.createElement('div', { className: "onboarding-payment--offer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 444}}
            , _react2.default.createElement('h1', { className: "onboarding-payment--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 445}}, "We hit a snag finishing your setup"      )
            , _react2.default.createElement('p', { className: "onboarding-payment--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 446}}, "Your payment went through, but your subscription hasn't finished activating yet. Try again in a moment — if this keeps happening, contact "


               , _react2.default.createElement('a', { href: "mailto:support@bloomtext.com", __self: this, __source: {fileName: _jsxFileName, lineNumber: 449}}, "support@bloomtext.com"), " and we'll finish your setup."

            )
            , _react2.default.createElement(_Form.Button, {
              onClick: () => {
                settleAttemptsRef.current = 0
                setSettleState('pending')
              },
              className: "onboarding-payment--start", __self: this, __source: {fileName: _jsxFileName, lineNumber: 452}}
, "Try again"

            )
            , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: finishToReady, className: "onboarding-payment--skip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 461}}, "Continue"

            )
          )
        )
      )
    }
    if (settleState !== 'sms' || phoneResolved) return _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 468}}, _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 468}} ))
    emitOnce(guardKey('phone_viewed'), () =>
      _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.STEP_VIEWED, {
        ..._onboardingAnalytics.PHONE_STEP_META, organization_id: orgParam, attempt_id: attemptId,
      }))
    return (
      _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 474}}
        , _react2.default.createElement('div', { className: "onboarding-payment--offer onboarding-payment--phone" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 475}}
          , _react2.default.createElement(_Form4.default, {
            orgKey: orgParam,
            onRegistered: onPhoneRegistered,
            onReloadSubscription: reloadSubscription, __self: this, __source: {fileName: _jsxFileName, lineNumber: 476}}
          )
          , _react2.default.createElement(_Form.Button, {
            isSecondary: true,
            onClick: () => setPhoneSkipDialogOpen(true),
            className: "onboarding-payment--skip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 481}}
, "Do this later"

          )
        )
         /* Skipping silently stranded users who didn't know where to find
             their number later — the confirm names the exact Settings path. */ 
        , _react2.default.createElement(_Modal2.default, {
          isOpen: phoneSkipDialogOpen,
          onClose: () => setPhoneSkipDialogOpen(false),
          title: "Pick your number later?"   ,
          size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 491}}

          , _react2.default.createElement('p', { className: "onboarding-payment--skip-dialog--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 497}}, "No problem — your trial still includes a dedicated clinic number. You can pick it anytime in Settings → your organization → Plan."



          )
          , _react2.default.createElement('div', { className: "onboarding-payment--skip-dialog--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 502}}
            , _react2.default.createElement(_Form.Button, {
              isSecondary: true,
              onClick: () => setPhoneSkipDialogOpen(false),
              className: "onboarding-payment--skip-dialog--back", __self: this, __source: {fileName: _jsxFileName, lineNumber: 503}}
, "Go back"

            )
            , _react2.default.createElement(_Form.Button, {
              onClick: () => {
                setPhoneSkipDialogOpen(false)
                onPhoneSkip()
              },
              className: "onboarding-payment--skip-dialog--confirm", __self: this, __source: {fileName: _jsxFileName, lineNumber: 510}}
, "Skip for now"

            )
          )
        )
      )
    )
  }

  // Hold a loader until the survey settles (the enterprise cutoff + tier
  // preselection depend on it). A failed read
  // blocks on an explicit retry — proceeding on empty answers would misread an
  // SMS cohort as the free team path and silently drop the offer.
  if (!survey.loaded) {
    if (survey.failed) {
      return (
        _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 532}}
          , _react2.default.createElement('div', { className: "onboarding-payment--offer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 533}}
            , _react2.default.createElement('div', { className: "onboarding-payment--error-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 534}}
              , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 535}}, "We couldn't load your setup details."     )
              , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: survey.retry, className: "onboarding-payment--retry", __self: this, __source: {fileName: _jsxFileName, lineNumber: 536}}, "Retry"

              )
            )
          )
        )
      )
    }
    return _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 544}}, _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 544}} ))
  }

  if (status === 'cancelled' && !continuityValid) {
    return (
      _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 549}}
        , _react2.default.createElement('div', { className: "onboarding-payment--offer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 550}}
          , _react2.default.createElement('h1', { className: "onboarding-payment--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 551}}, "Restart checkout to continue"   )
          , _react2.default.createElement('p', { className: "onboarding-payment--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 552}}, "We couldn't verify this browser's checkout session. Restart checkout to continue safely."

          )
          , _react2.default.createElement(_Form.Button, {
            onClick: () => {
              _paymentContinuity.clearPaymentContinuity.call(void 0, orgParam)
              _actions2.default.gotoOnboardingPayment(orgParam)
            },
            className: "onboarding-payment--start", __self: this, __source: {fileName: _jsxFileName, lineNumber: 555}}
, "Restart checkout"

          )
        )
      )
    )
  }

  // Payment (enterprise contact-us branch first).
  if (isEnterprise) {
    return (
      _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 572}}
        , _react2.default.createElement('div', { className: "onboarding-payment--offer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 573}}
          , _react2.default.createElement('h1', { className: "onboarding-payment--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 574}}, "Let's build your plan together"    )
          , _react2.default.createElement('p', { className: "onboarding-payment--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 575}}, "At more than "
               ,  _onboardingShared.MAX_SELF_SERVE_PATIENTS_PER_MONTH.toLocaleString() , " patients a month, our team will tailor volume pricing to your organization."

          )
          , _react2.default.createElement(_Form.Button, {
            onClick: () => onDemoClick('enterprise_branch'),
            className: "onboarding-payment--start", __self: this, __source: {fileName: _jsxFileName, lineNumber: 579}}
, "Contact our team"

          )
          , _react2.default.createElement(_Form.Button, {
            isSecondary: true,
            onClick: () => onSkipToReady({ estimates: {} }),
            className: "onboarding-payment--skip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 585}}
, "Continue to my inbox"

          )
        )
      )
    )
  }

  return (
    _react2.default.createElement(_onboardingShared.OnboardingLayout, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 598}}
      , _react2.default.createElement(_TrialOffer2.default, {
        prices: items,
        hasSms: hasSms,
        hasTeamChat: hasTeamChat,
        hasExternalChat: hasExternalChat,
        selectedTier: selectedTier,
        onSelectedTierChange: setSelectedTier,
        isLoadingPricing: isLoadingPricing,
        hasPricingError: hasPricingError,
        onRetryPricing: loadPricing,
        isAvailable: clientOpen,
        isStarting: isStarting,
        actionError: hasCheckoutError ? "We couldn't start checkout. Please try again." : undefined,
        onStart: onStart,
        onSkip: onSkipToReady,
        onFreeContinue: onFreeContinue,
        onDemo: action => onDemoClick('enterprise_callout', action),
        onDemoViewed: onDemoViewed,
        onSkipDialogViewed: onSkipOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 599}}
      )
    )
  )
}

// Org-scoped state (attempt id, survey, pricing, settle state)
// must never survive an ?org= switch on the same route — a multi-org admin can
// reach this screen for another org (e.g. via the global trial banner) while
// it is already mounted, and React Router preserves the component when only
// the query changes. Keying by org forces a clean remount per org.
const OnboardingPaymentByOrg = () => {
  const { status } = _reactrouterdom.useParams()
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const orgKey = new URLSearchParams(search).get('org') || ''
  const attempt = new URLSearchParams(search).get('attempt') || ''
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  return (
    _react2.default.createElement(OnboardingPayment, {
      key: `${orgKey}:${_optionalChain([currentUser, 'optionalAccess', _3 => _3.UserKey]) || ''}:${status || 'initial'}:${attempt}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 635}}
    )
  )
}

exports. default = OnboardingPaymentByOrg
